const testimonials = [
  {
    name: "Carlos M.",
    location: "Pembroke Pines, FL",
    rating: 5,
    text: "My mother in Medellin needed emergency surgery and I discovered my passport had expired two months prior. I was panicking — I needed to be on a flight to Bogota in five days. I started with Fast Passport Center Monday morning, shipped everything from the FedEx on Pines Boulevard that afternoon, and had my renewed passport Thursday evening. I was on my flight Friday morning. I cannot express how much this service meant to my family.",
    service: "Passport Renewal",
  },
  {
    name: "Rachel S.",
    location: "Pembroke Pines, FL",
    rating: 5,
    text: "Our daughter's bat mitzvah group trip to Israel was scheduled for June. In April I checked her passport and realized it would expire three months before our return date — Israel requires six months validity. We were two months from departure with a group of twelve families, all with non-refundable deposits. Fast Passport Center processed her renewal in four business days. The entire group trip was saved, and I have recommended them to three other families in our temple.",
    service: "Child Passport",
  },
  {
    name: "James R.",
    location: "Pembroke Pines, FL",
    rating: 5,
    text: "I'm a pharmaceutical sales rep covering Latin America from my home office in Pembroke Pines. I had a product launch meeting in Mexico City in nine days when I pulled my passport and discovered it had expired six months ago — I simply never checked. Fast Passport Center had my renewal processed and back to me in three business days. I've since set a calendar reminder, but I know who to call if I ever need emergency service again.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PembrokePinesTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Pembroke Pines Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Pembroke Pines, Miramar, and southwestern Broward County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}